import { gql } from '@apollo/client';

export const COMPLETE_INVESTMENT = gql`
  mutation CompleteInvestment($id: String!) {
    completeInvestment(input: { id: $id }) {
      statusCode
      message
      error
      investment {
        id
        status
        completedAt
      }
    }
  }
`;
